import getSingle from "./get-single.js";
import updateSingle from "./update-single.js";

export default {
	getSingle,
	updateSingle,
};
